export default function About() {
  return (
    <section id="apropos" className="py-20 md:py-28 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-10">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          <div className="relative">
            <div className="relative rounded-lg overflow-hidden">
              <img
                src="https://storage.helloreaddy.io/project_files/179a8203-21a2-4b5f-9e7d-c89fcdd8c7e7/5a421701-3b27-4297-a652-28199feddf25_compressed_56c753e4-e0e7-49e5-9b4e-19157cda03d5.webp"
                alt="Entrepôt Godwin Logistics en Chine"
                className="w-full h-[560px] object-cover object-top"
              />
            </div>
            <div className="absolute -bottom-6 -right-4 md:-right-8 bg-primary-500 text-white p-6 rounded-lg max-w-xs">
              <div className="font-heading text-4xl font-bold">2026</div>
              <div className="text-sm mt-1 text-white/90">Année de fondation, une nouvelle référence maritime</div>
            </div>
          </div>

          <div>
            <span className="text-primary-600 text-sm font-semibold uppercase tracking-widest">À propos</span>
            <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-900 mt-3 leading-tight">
              La mer, extension fluide de votre chaîne logistique
            </h2>
            <p className="mt-6 text-foreground-700 leading-relaxed">
              Fondé en 2026, <strong>Godwin Logistics</strong> s'est développé pour devenir un commissionnaire de transport international de référence. Spécialisé dans le fret maritime, nous connectons les continents et accompagnons les clients dans le déploiement de leurs flux de colis provenant de la Chine, depuis nos hubs stratégiques.
            </p>

            <div className="mt-8 p-6 rounded-lg bg-background-100 border-l-4 border-primary-500">
              <div className="flex items-center gap-2 text-primary-700 font-semibold mb-2">
                <i className="ri-focus-3-line w-5 h-5 flex items-center justify-center"></i>
                Notre Mission
              </div>
              <p className="text-foreground-700 leading-relaxed text-sm md:text-base">
                Assurer le transport sécurisé, économique et fiable de vos colis par voie maritime et routière — qu'il s'agisse de conteneurs complets ou de groupages. Nous optimisons vos routes maritimes et prenons en charge l'ensemble des formalités douanières.
              </p>
            </div>

            <div className="mt-8 grid grid-cols-2 gap-4">
              {[
                { i: 'ri-earth-line', t: 'Hubs stratégiques', d: 'Présence directe en Chine (Guangzhou, Shenzhen, Yiwu)' },
                { i: 'ri-shield-check-line', t: 'Douane maîtrisée', d: 'Import & export sans stress' },
                { i: 'ri-home-4-line', t: 'Siège social', d: 'Bâtiment AMAZON, Lubumbashi' },
                { i: 'ri-exchange-dollar-line', t: 'Transaction de fonds', d: 'Bank, WeChat, Alipay' },
              ].map((f, i) => (
                <div key={i} className="p-4 rounded-md bg-background-100 border border-background-200">
                  <div className="w-10 h-10 flex items-center justify-center rounded-md bg-primary-500 text-white mb-3">
                    <i className={`${f.i} text-lg`}></i>
                  </div>
                  <div className="font-semibold text-foreground-900 text-sm">{f.t}</div>
                  <div className="text-xs text-foreground-600 mt-1">{f.d}</div>
                </div>
              ))}
            </div>

            <div className="mt-6 p-4 rounded-md bg-secondary-50 border border-secondary-200">
              <div className="flex items-start gap-3">
                <div className="w-8 h-8 flex items-center justify-center rounded-full bg-secondary-200 text-secondary-700 shrink-0">
                  <i className="ri-map-pin-2-line text-sm"></i>
                </div>
                <div>
                  <div className="text-sm font-semibold text-foreground-900">Adresse entrepôt Chine</div>
                  <div className="text-xs text-foreground-600 mt-1 leading-relaxed">
                    广州市白云区人和镇建南村庙仔街南广州得劳斯佳人集装箱厂内<br/>
                    导航：得劳斯佳人佳人集装箱厂 · 入仓号 CTB670-B
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}